import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { updateFirmInfoAction } from '../APIs/action';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import {
  GetAllCityOfState,
  getLocationAndPincodeAction,
} from '../../Onboarding/auth/action';
const GeographyDetailCard = ({ firmData, onRefresh = () => {} }) => {
  const [firm, setFirm] = useState(firmData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [districtList, setDistrictList] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allPincodes, setAllPincodes] = useState([]);
  const [firstSelection, setFirstSelection] = useState(null);
  const getAllDistrict = async (id) => {
    const { error, data, message } = await GetAllCityOfState(id);

    if (!error) {
      setDistrictList(data);
    } else {
      return toast.error(message);
    }
  };

  const getlocationPincode = async (
    districtId,
    locationId = null,
    PincodeId = null,
  ) => {
    if (PincodeId && firm.geographic_info.location_info.location_id) return;
    if (locationId && firm.geographic_info.pincode_info.pincode_id) return;
    const { data, error } = await getLocationAndPincodeAction(districtId, {
      location_id: locationId,
      pincode_id: PincodeId,
    });
    if (!error) {
      if (locationId && !firm.geographic_info.pincode_info.pincode_id) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
      } else if (PincodeId && !firm.geographic_info.location_info.location_id) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      } else if (!locationId && !PincodeId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      }
    }
  };
  useEffect(() => {
    if (
      firm?.geographic_info?.district_info?.district_id &&
      !firm.geographic_info.location_info.location_id &&
      !firm.geographic_info.pincode_info.pincode_id
    ) {
      getlocationPincode(firm?.geographic_info?.district_info?.district_id);
    }
  }, [firm?.geographic_info?.district_info?.district_id]);

  useEffect(() => {
    if (
      firm?.geographic_info?.district_info?.district_id &&
      firm.geographic_info.location_info.location_id
    ) {
      getlocationPincode(
        firm?.geographic_info?.district_info?.district_id,
        firm.geographic_info.location_info.location_id,
        null,
      );
    }
  }, [firm.geographic_info.location_info.location_id]);
  useEffect(() => {
    if (
      firm?.geographic_info?.district_info?.district_id &&
      firm.geographic_info.pincode_info.pincode_id
    ) {
      getlocationPincode(
        firm?.geographic_info?.district_info?.district_id,
        null,
        firm.geographic_info.pincode_info.pincode_id,
      );
    }
  }, [firm.geographic_info.pincode_info.pincode_id]);
  useEffect(() => {
    getAllDistrict(firm?.geographic_info?.state_info?.state_id);
    getlocationPincode(firm?.geographic_info?.district_info?.district_id);
  }, []);
  const [isGeographyDetailEditing, setIsGeographyDetailEditing] =
    useState(false);

  const handleGeographyDetailEditClick = async (firm) => {
    if (firm.geographic_info.location_info.location_id === null) {
      return toast.error('Please select City');
    }
    if (firm.geographic_info.pincode_info.pincode_id === null) {
      return toast.error('Please select Pincode');
    }
    if (firm.geographic_info.address_info.address_line_1 === '') {
      return toast.error('Please Add Address Line 1');
    }
    const payload = {
      id: firm?.company_id,
      pincode: firm.geographic_info.pincode_info.pincode_id,
      address_line_1: firm.geographic_info.address_info.address_line_1,
      address_line_2: firm.geographic_info.address_info.address_line_2,
      address_line_3: firm.geographic_info.address_info.address_line_3,
      district_id: firm.geographic_info.district_info.district_id,
      location_id: firm.geographic_info.location_info.location_id,
    };
    if (isGeographyDetailEditing) await onUpdate(payload);
    setIsGeographyDetailEditing(!isGeographyDetailEditing);
  };

  const handleGeographyDetailDiscardClick = () => {
    setIsGeographyDetailEditing(false);
    onRefresh();
  };

  const onUpdate = async (payload) => {
    const { data, error, message } = await updateFirmInfoAction(payload);
    if (!error) {
      toast.success('Request has been sent for approval');
      onRefresh();
    } else {
      onRefresh();
      return toast.error(message);
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (
      name === 'geographic_info.location_info.location_id' &&
      !firstSelection
    ) {
      setFirstSelection('city');
    }
    if (name === 'geographic_info.pincode_info.pincode_id' && !firstSelection) {
      setFirstSelection('pincode');
    }
    let updatedFirm = _.cloneDeep(firm);
    const updateNestedProperty = (obj, path, value) => {
      const keys = path.split('.');
      let current = obj;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
    };
    updateNestedProperty(updatedFirm, name, value);

    if (name === 'geographic_info.district_info.district_id') {
      setFirstSelection(null);
      updateNestedProperty(
        updatedFirm,
        'geographic_info.location_info.location_id',
        null,
      );
      updateNestedProperty(
        updatedFirm,
        'geographic_info.pincode_info.pincode_id',
        null,
      );
      updateNestedProperty(
        updatedFirm,
        'geographic_info.address_info.address_line_1',
        '',
      );
      updateNestedProperty(
        updatedFirm,
        'geographic_info.address_info.address_line_2',
        '',
      );
      updateNestedProperty(
        updatedFirm,
        'geographic_info.address_info.address_line_3',
        '',
      );
    }
    if (
      name === 'geographic_info.location_info.location_id' &&
      firstSelection === 'city'
    ) {
      updateNestedProperty(
        updatedFirm,
        'geographic_info.pincode_info.pincode_id',
        null,
      );
    }
    if (
      name === 'geographic_info.pincode_info.pincode_id' &&
      firstSelection === 'pincode'
    ) {
      updateNestedProperty(
        updatedFirm,
        'geographic_info.location_info.location_id',
        null,
      );
    }
    setFirm(updatedFirm);
  };

  return (
    <Card sx={{ mt: '1rem' }}>
      <CardHeader
        title='Geography Detail'
        sx={{ backgroundColor: '#f5f5f5' }}
        action={
          <Stack
            direction='row'
            spacing={2}
          >
            <Tooltip title={isGeographyDetailEditing ? 'Save' : 'Edit'}>
              <IconButton
                color='primary'
                onClick={() => handleGeographyDetailEditClick(firm)}
              >
                {isGeographyDetailEditing ? (
                  <CheckIcon sx={{ color: 'green' }} />
                ) : (
                  <EditIcon />
                )}
              </IconButton>
            </Tooltip>
            {isGeographyDetailEditing && (
              <Tooltip title='Discard'>
                <IconButton
                  color='primary'
                  onClick={handleGeographyDetailDiscardClick}
                >
                  <CloseIcon sx={{ color: 'red' }} />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        }
      />
      <CardContent>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              State
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <TextField
              disabled={true}
              label='State'
              name='state_name'
              value={firm?.geographic_info?.state_info?.state_name}
              fullWidth
              margin='normal'
            />
          </Grid>
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              District
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <FormControl
              fullWidth
              disabled={!isGeographyDetailEditing}
            >
              <InputLabel id='demo-simple-select-label'>District</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={firm?.geographic_info?.district_info?.district_id}
                name='geographic_info.district_info.district_id'
                label='District'
                onChange={(event) => (
                  handleChange(event), getlocationPincode(event.target.value)
                )}
              >
                {districtList.map((item) => (
                  <MenuItem value={item.id}>{item.district_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              City
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <FormControl
              fullWidth
              disabled={!isGeographyDetailEditing}
              margin='normal'
            >
              <InputLabel id='demo-simple-select-label'>City</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={firm?.geographic_info?.location_info?.location_id}
                name='geographic_info.location_info.location_id'
                label='City'
                onChange={(event) => handleChange(event)}
                margin='normal'
              >
                {allCities.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Pincode
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <FormControl
              fullWidth
              disabled={!isGeographyDetailEditing}
            >
              <InputLabel id='demo-simple-select-label'>Pincode</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={firm?.geographic_info?.pincode_info?.pincode_id}
                name='geographic_info.pincode_info.pincode_id'
                label='Pincode'
                onChange={(event) => handleChange(event)}
              >
                {allPincodes.map((item) => (
                  <MenuItem value={item.value}>{item.value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {/* City, Pincode */}
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Address Line 1
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <TextField
              disabled={!isGeographyDetailEditing}
              label='Address Line 1'
              name='geographic_info.address_info.address_line_1'
              value={firm?.geographic_info?.address_info?.address_line_1}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
          {/* Address Line 1 */}
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Address Line 2
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={4}
            alignContent='center'
          >
            <TextField
              disabled={!isGeographyDetailEditing}
              label='Address Line 2'
              name='geographic_info.address_info.address_line_2'
              value={firm?.geographic_info?.address_info?.address_line_2}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
          {/* Address Line 2 */}
        </Grid>
        {/* Address Line 2 */}
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={6}
            md={2}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Address Line 3
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={10}
            alignContent='center'
          >
            <TextField
              disabled={!isGeographyDetailEditing}
              label='Address Line 3'
              name='geographic_info.address_info.address_line_3'
              value={firm?.geographic_info?.address_info?.address_line_3}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default GeographyDetailCard;
